/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import { cellRendererWithoutDec, amountComparator } from '../../../../SharedModules/utilities/utilities';
const greyCellRule = {
  'grey-cell': (params) => {
    const rowName = params.data?.field1;
    const field = params.colDef.field;

    if (rowName === '1.Balance as of Beginning of the Quarter') {
      return field === 'field2';
    }
    if (rowName === '3.Rebates Established this Quarter') {
      return (
        field === 'field3' ||
        field === 'field4' ||
        field === 'field5' ||
        field === 'field6'
      );
    }
    return false;
  },
};

const freezeMismatchRule = {
  'freeze-mismatch': (params) =>
    Boolean(params.data?.__freezeMismatch?.[params.colDef.field]),
};

const amountCellClassRules = {
  ...greyCellRule,
  ...freezeMismatchRule,
};

const greyAwareAmountRenderer = (params) => {
  const value = Number(params.value);

  // Check if this cell matches the grey rule
  const isGreyCell =
    greyCellRule['grey-cell'] &&
    greyCellRule['grey-cell'](params);

  // If grey cell AND value is 0 → show blank
  if (isGreyCell && value === 0) {
    return '';
  }

  return cellRendererWithoutDec(params);
};



// -ve value in red and bracket
const textMatcherAmount = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 ||
        valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText || valueWithDollar.indexOf(filterText) != 0;
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) ||
        valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};
const MultiLineHeaderComponent = () => {
  return (
    <div style={{ whiteSpace: 'normal' }}>
      <div>Drug Rebate</div>
      <br />
      <div>Rebate Quarter</div>
    </div>
  );
};

export const CMS64Head = [
  {
    headerName: 'Drug Rebate',
    field: 'field1',
    headerComponentFramework: MultiLineHeaderComponent,
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: true,
    wrapText: true,
    columnSpan: 3,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['asc', 'desc'],
    comparator: amountComparator,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Quarter Ending ',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: greyAwareAmountRenderer,
    field: 'field2',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['asc', 'desc'],
    comparator: amountComparator,
    cellClassRules: amountCellClassRules,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },

  {
    headerName: 'Quarter Ending  ',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: greyAwareAmountRenderer,
    field: 'field3',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['asc', 'desc'],
    comparator: amountComparator,
    cellClassRules: amountCellClassRules,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },

  {
    headerName: 'Quarter Ending   ',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: greyAwareAmountRenderer,
    field: 'field4',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,
    sortingOrder: ['asc', 'desc'],
    cellClassRules: amountCellClassRules,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },

  {
    headerName: 'Quarter Ending    ',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: greyAwareAmountRenderer,
    field: 'field5',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    sortingOrder: ['asc', 'desc'],
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,
    cellClassRules: amountCellClassRules,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },

  {
    headerName: 'Previous Quarter',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: greyAwareAmountRenderer,
    field: 'field6',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_167,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,
    cellClassRules: amountCellClassRules,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },

  {
    headerName: 'Final Totals',
    printPrefixValue: '$',
    isTextColorRed: true,
    cellRenderer: cellRendererWithoutDec,
    field: 'field7',
    editable: false,
    sortable: false,
    suppressMenu: false,
    resizable: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    comparator: amountComparator,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: textMatcherAmount,
    },
  },
];

export const defaultTableHead = [];
